import Vue from 'vue';
import axios from './router/axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router/router';
import './permission'; // 权限
import './error'; // 日志
import './cache';//页面缓存
import store from './store';
import {loadStyle} from './util/util'
import * as urls from '@/config/env';
import Element from 'element-ui';
import {
  iconfontUrl,
  iconfontVersion
} from '@/config/env';
import i18n from './lang'; // Internationalization
import './styles/common.scss';
import './styles/vd-common.scss';
import basicBlock from './components/basic-block/main';
import basicContainer from './components/basic-container/main';
import thirdRegister from './components/third-register/main';
import avueUeditor from 'avue-plugin-ueditor';
import website from '@/config/website';

import AvueFormDesign from '../packages/';
import AvueUeditor from 'avue-plugin-ueditor';
import inputFilter from './util/input'

Vue.directive('inputFilter', inputFilter)

import moneyInput from '@/components/money-input'
Vue.component('moneyInput', moneyInput);
Vue.use(window.AVUE);
Vue.use(AvueFormDesign);
Vue.use(AvueUeditor);


Vue.config.productionTip = false;

import Vant from 'vant';
Vue.use(Vant);
import { Dialog } from 'vant';
Vue.prototype.$vantDialog = Dialog;
import { Notify } from 'vant';


import _ from 'lodash';
Vue.prototype._ = _;

import crudCommon from '@/mixins/crud';
// 注册全局crud驱动
window.$crudCommon = crudCommon;
// 加载Vue拓展
Vue.use(router);
Vue.use(VueAxios, axios);
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(window.AVUE, {
  size: 'small',
  tableSize: 'small',
  calcHeight: 60,
  i18n: (key, value) => i18n.t(key, value)
});
// 注册全局容器
Vue.component('basicContainer', basicContainer);
Vue.component('basicBlock', basicBlock);
Vue.component('thirdRegister', thirdRegister);
Vue.component('avueUeditor', avueUeditor);
// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key];
});
// 加载website
Vue.prototype.website = website;
// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
  loadStyle(iconfontUrl.replace('$key', ele));
});
import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;

Vue.prototype.bodyHeight = document.body.clientHeight;
Vue.prototype.bodyWidth = document.body.clientWidth;

Vue.config.productionTip = false;
import baiduMap from 'vue-baidu-map';
Vue.use(baiduMap, {
  ak: 'Npv1v9G817Vv9eHQoAo47ZGInK9ZYpax'
})
import vdui from '@/util/vdui';
Vue.prototype.vdui = vdui;
import tool from '@/util/tool';
Vue.prototype.tool = tool;
// Vue.use(VueBaiduMap.default, {
//   ak: 'Npv1v9G817Vv9eHQoAo47ZGInK9ZYpax'
// })
// window.onload = ()=>{
//   console.log('window.onload');
// }

// window.onunload = ()=>{
//   console.log('window.onunload');
// }
// window.onbeforeunload = ()=>{
//   console.log('window.onbeforeunload');
// }

// 表单验证对象
import { validation } from '@/util/validation.js';
Vue.prototype.$validation = validation;

// 票据打印组件
import printPreview from '@/views/v4ward/pay/printdialog-new/printPreview';
Vue.component('t-printPreview',printPreview);

// 发票打印组件
import PrintAndInvoice from '@/views/v4ward/digitaltickets/compoents/print-and-invoice';
Vue.component('t-PrintAndInvoice',PrintAndInvoice);

// 发票打印组件
import TaxInvoiceApplyDialog from '@/views/v4ward/digitaltickets/compoents/tax-invoice-apply-dialog';
Vue.component('t-TaxInvoiceApplyDialog',TaxInvoiceApplyDialog);

// 自定义列显隐组件
import showHidden from "@/components/showHidden/showHidden";
Vue.component('wq-showHidden',showHidden);

// 自定义数据导出组件
import exportData from "@/components/exportData/exportData";
Vue.component('wq-exportData',exportData);

// 自定义超出隐藏组件
import wqOverHidden from "@/components/table/table-overHidden";
Vue.component('wq-overHidden',wqOverHidden);

// 选择合同组件
import choiceContract from "@/components/choiceContract/choiceDeviceContractv2";
Vue.component('wq-choiceContract',choiceContract);

//自定义diaolog对话框组件
import hrDialog from "@/components/dialog/index";
Vue.component('hr-dialog',hrDialog);

//自定义下拉框搜索组件
import selectSearch from "@/components/selectSearch/index.vue";
Vue.component('selectSearch',selectSearch);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

import Print from 'vue-print-nb';
Vue.use(Print);

